'use strict';

var _classCallCheck = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/codebuild/output/src773985007/src/validafy/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var TransformStream = require('readable-stream').Transform;

var PubsubMessage = require('./pubsub-message-utils');

var PubsubMessageStream = /*#__PURE__*/function (_TransformStream) {
  _inherits(PubsubMessageStream, _TransformStream);

  function PubsubMessageStream(options) {
    _classCallCheck(this, PubsubMessageStream);

    var opts = Object.assign(options || {}, {
      objectMode: true
    });
    return _possibleConstructorReturn(this, _getPrototypeOf(PubsubMessageStream).call(this, opts));
  }

  _createClass(PubsubMessageStream, [{
    key: "_transform",
    value: function _transform(obj, enc, callback) {
      // go-ipfs returns '{}' as the very first object atm, we skip that
      if (Object.keys(obj).length === 0) {
        return callback();
      }

      try {
        var msg = PubsubMessage.deserialize(obj, 'base64');
        this.push(msg);
        callback();
      } catch (err) {
        return callback(err);
      }
    }
  }], [{
    key: "from",
    value: function from(inputStream, callback) {
      var outputStream = inputStream.pipe(new PubsubMessageStream());
      inputStream.on('end', function () {
        return outputStream.emit('end');
      });
      callback(null, outputStream);
    }
  }]);

  return PubsubMessageStream;
}(TransformStream);

module.exports = PubsubMessageStream;